import { createContext } from 'react';
import { DataContext } from '../domain/types';


export const Context2 = createContext<DataContext>({});

